import { useListingData } from "~/context/ListingPageDataContext";

import { FsvCardGrid } from "../FsvCardGrid";

export const FsvSection = () => {
  const { data: listingData } = useListingData();

  if (!listingData) {
    return null;
  }

  return (
    <div className="tw-mt-16">
      <FsvCardGrid />
    </div>
  );
};
